var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44476 17.5062C7.44476 17.9326 7.21658 18.187 6.89302 18.187C6.77893 18.187 6.65175 18.1552 6.51709 18.0878L1.29893 15.4451C0.992199 15.2898 0.741577 14.8784 0.741577 14.5324V1.57862C0.741577 1.23635 0.922997 1.03436 1.18297 1.03436C1.27461 1.03436 1.37748 1.05867 1.48409 1.11291L1.66738 1.20643H1.66925L7.42044 4.1185C7.4298 4.12411 7.43728 4.13346 7.44476 4.14094V17.5062ZM13.4709 1.85168L13.8225 1.27376C13.9478 1.06802 14.1779 0.950195 14.4117 0.950195C14.4659 0.950195 14.522 0.957677 14.5762 0.972639C14.6174 0.98199 14.6604 0.996953 14.7053 1.0194L20.7707 4.09044C20.7726 4.09044 20.7726 4.09231 20.7726 4.09231L20.7782 4.09418C20.7819 4.09605 20.7819 4.10166 20.7857 4.10354C20.8156 4.12785 20.8287 4.169 20.8081 4.20266L14.767 14.1452L14.1498 15.1589L10.1474 7.32046L13.4709 1.85168ZM8.40236 12.2525V6.00751L12.7022 14.4314L8.8344 12.4732L8.40236 12.2525ZM20.8511 17.5062C20.8511 17.9064 20.6136 18.1346 20.2638 18.1346C20.1067 18.1346 19.9272 18.0897 19.7383 17.9943L18.8723 17.5548L15.0045 15.5966L20.8511 5.97571V17.5062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkone);
export default __webpack_public_path__ + "static/media/linkone.a477a51ec15ff52edfd90daf66496cb4.svg";
export { ForwardRef as ReactComponent };